import {InvitedGigDto} from '@/api/gigs/types';
import {InvitedGig} from '@/types/gigs';
import {mapUserCampaignListItemDtoToCollaborationGigBase} from '../common';

/**
 * Maps an invited gig DTO from the API to the UI invited gig model
 * @param dto The invited gig DTO from the API
 * @returns The mapped invited gig model for use in the UI
 */
export default function mapInvitedGigDtoToInvitedGig(
  dto: InvitedGigDto
): InvitedGig {
  const collaborationGig = mapUserCampaignListItemDtoToCollaborationGigBase(
    dto.userCampaignListItem
  );
  return {
    ...collaborationGig,
    type: 'invite',
    recruitedStatus: dto.recruitedStatus as 'applied' | 'dismissed' | 'pending',
    invitedStatus: dto.invitedStatus as 'applied' | 'dismissed',
    invitedAt: dto.invitedAt ? new Date(dto.invitedAt) : undefined,
    recruitedAt: dto.recruitedAt ? new Date(dto.recruitedAt) : undefined,
    brandDismissedAt: dto.brandDismissedAt
      ? new Date(dto.brandDismissedAt)
      : undefined,
    creatorDismissedAt: dto.creatorDismissedAt
      ? new Date(dto.creatorDismissedAt)
      : undefined,
    brandSuggested: dto.brandSuggested,
    origination: dto.origination,
  };
}
